<template lang="pug">
div
  v-row.phone-input(no-gutters align="center" :style="isActive ? `border: 1.5px solid #333` : ''")
    div
    v-col.shrink
      v-select(
        v-model="dialCode"
        @focus="onFocus"
        @blur="onBlur"
        @keypress="searchCountry($event)"
        :items="countryList"
        item-value="iso"
        solo
        hide-details
        flat
        append-icon="mdi-chevron-down"
      )
        template(v-slot:selection="{ item, index }")
          img(:src="require(`@/assets/images/flags/${item.iso}.png`)" width="22px" height="14px")
        template(v-slot:item="{ item, on, attrs }")
          v-row(no-gutters v-on="on" align="center")
            v-col.shrink.pr-1
              div(style="height: 18px;")
                img(:src="require(`@/assets/images/flags/${item.iso}.png`)" width="22px" height="14px")
            v-col.pl-1
              div(style="line-height: 20px;") {{ item.name }}
                strong.ml-2 +{{ item.dialCode }}
    v-col
      .text-xs.neutral500--text.mt-2 {{ placeholder }}
      .d-flex.align-center.mt-n2
        .text-md.neutral500--text(style="margin-top: 2px; margin-right: -8px;") +{{ countryCode }}
        v-text-field(
          v-model="dialNumber"
          hide-details
          solo
          flat
          dense
          :rules="dialCode === 'my' ? rules.phone : rules.phone_inter"
          @keypress="isNumber($event)"
          type="tel"
          @focus="onFocus"
          @blur="onBlur"
          background-color="transparent"
        )
  .text-caption.ml-3.error--text.mt-1(v-if="phoneAlertMessage") {{ phoneAlertMessage }}
</template>

<script>
import { DateTime } from 'luxon'
import { countries } from '@/assets/phoneCodeCountries.js'
export default {
  name: 'YPhoneInput',
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Enter phone number'
    }
  },
  data: () => ({
    dialCode: 'my',
    dialNumber: '',
    searchString: '',
    phoneAlertMessage: '',
    filteredCountry: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [
        v => !!v || 'Phone number is required',
        v => /^(01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone number must be valid'
      ],
      phone_inter: [v => !!v || 'Phone number is required']
    },
    bgColor: 'transparent',
    isActive: false
  }),
  computed: {
    countryList () {
      if (this.filteredCountry.length > 0) {
        return this.filteredCountry
      }
      return countries
    },
    phoneNumber () {
      const dialcode = this.countryList.filter(f => f.iso === this.dialCode)[0].dialCode
      if (this.dialNumber.startsWith(dialcode)) {
        return this.dialNumber
      }
      return dialcode + this.dialNumber
    },
    countryCode () {
      return this.countryList.filter(f => f.iso === this.dialCode)[0].dialCode
    },
  },
  watch: {
    dialNumber () {
      this.phoneValidation()
    },
    dialCode () {
      this.phoneValidation()
    },
    phoneNumber: {
      immediate: true,
      handler (val) {
        this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.value) {
        const num = this.value
        for (let i = 4; i > 0; i--) {
          const country = this.countryList.filter(f => f.dialCode === num.substr(0, i) && f.priority === 0)
          if (country.length > 0) {
            this.dialCode = country[0].iso
            this.dialNumber = num.substr(i)
            break
          }
        }
      }
      if (!this.dialNumber) {
        const zoneId = DateTime.local().toFormat('z')
        const country = this.$options.filters.getCountryCodeFromZoneId(zoneId)
        const phoneCountry = this.countryList.filter(f => f.isoUpper === country)
        if (phoneCountry.length > 0) {
          this.dialCode = phoneCountry[0].iso
        }
      }
    })
  },
  methods: {
    isNumber (evt) {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onBlur () {
      this.$emit('blur', true)
      this.searchString = ''
      this.filteredCountry = []
      if (!this.dialNumber) {
        this.phoneAlertMessage = 'Phone number is required'
      }
      this.bgColor = 'transparent'
      this.isActive = false
    },
    onFocus () {
      this.$emit('focus', false)
      this.bgColor = 'transparent'
      this.isActive = true
    },
    searchCountry (evt) {
      if (this.searchString) {
        this.searchString += evt.key
        this.filteredCountry = countries.filter(f => f.name.toLowerCase().slice(0, this.searchString.length) === this.searchString)
        if (this.filteredCountry.length === 0) {
          this.searchString = ''
        }
      } else {
        this.searchString = evt.key
        this.filteredCountry = countries.filter(f => f.name.toLowerCase().slice(0, this.searchString.length) === this.searchString)
        if (this.filteredCountry.length === 0) {
          this.searchString = ''
        }
      }
    },
    phoneValidation () {
      if (this.dialCode === 'my') {
        if (!this.dialNumber) {
          this.phoneAlertMessage = 'Phone number is required'
        } else if (/^(01)[0-46-9]-*[0-9]{7,8}$/.test(this.dialNumber)) {
          this.phoneAlertMessage = ''
        } else {
          this.phoneAlertMessage = 'Phone number must be valid'
        }
      } else if (!this.dialNumber) {
        this.phoneAlertMessage = 'Phone number is required'
      } else {
        this.phoneAlertMessage = ''
      }
    }
  }
}
</script>

<style scoped>
.phone-input {
  border: 1px solid #c1c1c1;
  border-radius: 10px;
  overflow: hidden;
  height: 56px
}
::v-deep .v-text-field__slot input {
  font-size: 16px;
}

::v-deep .v-input.v-input--is-focused .v-input__slot {
  background-color: transparent !important;
}
</style>